module.exports = __webpack_public_path__ + "img/ga.3f4840cd.svg";